import { $utils, $hasAuthorization } from 'src/entities/iterable/model/core'
import { IterableController } from 'src/entities/iterable/ui/IterableController'

const iterableModel = {
  $utils,
  $hasAuthorization,
}

export { iterableModel, IterableController }
